/* eslint-disable consistent-return */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
import PptxGenJS from 'pptxgenjs';
import logo from '../../../shared/img/logo/logo_MW.png';
import addSlide1 from './slides/slide1';
import addSlide2 from './slides/slide2';
import addSlideProgram from './slides/slideProgram';
import groupServices from '../../../redux/services/groupServices';
import moduleServices from '../../../redux/services/moduleServices';
import contentNameEnToFr from '../../../helpers/unitsTranslation';
import addSlideExam from './slides/slideExam';
import addSlide3 from './slides/slide3';
import addSlide4 from './slides/slide4';
import addSlide5 from './slides/slide5';
import addSlide6 from './slides/slide6';
import addSlide7 from './slides/slide7';
import addSlide8 from './slides/slide8';
import codeServices from '../../../redux/services/codeServices';

function addBrandingToSlide(pptx, slide) {
  // Cercle blanc derrière le logo
  slide.addShape(pptx.ShapeType.ellipse, {
    x: 0.05,
    y: 0.05,
    w: 0.8,
    h: 0.8, // w = h -> cercle
    fill: { color: 'FFFFFF' },
    line: { color: 'FFFFFF' }, // pas de bordure visible
  });

  // Logo au-dessus du cercle
  slide.addImage({
    path: logo,
    x: 0.1,
    y: 0.15,
    w: 0.8,
    h: 0.5,
  });
}

export default async function generatePowerPoint(company, data, upload) {
  const finalGroupArr = [];
  const codes = await codeServices.getCodesByCompanyId(company._id);
  let sortedCodes = [];
  if (codes && codes.length > 0) {
    sortedCodes = codes.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
  }
  const res = await groupServices.getGroupsDataByCompagny(company._id);
  if (res && res.data) {
    const groupsArr = Object.values(res.data);
    if (groupsArr && groupsArr.length > 0) {
      await Promise.all(groupsArr.map(async (group) => {
        if (group.courses && group.courses.length > 0) {
          await Promise.all(group.courses.map(async (course) => {
            if (course.listModules && course.listModules.length > 0) {
              course.filledModules = [];
              await Promise.all(course.listModules.map(async (module) => {
                const resModule = await moduleServices.getModuleById(module);
                const text = contentNameEnToFr[resModule.name] || resModule.name;
                course.filledModules.push({ ...resModule, name: text });
              }));
            }
          }));
        }
      }));
    }
    groupsArr.forEach((group) => {
      if (group.level === 1) {
        finalGroupArr.push(group);
      }
    });
    data.semesters.forEach((semester) => {
      finalGroupArr.forEach((group) => {
        if (semester.semester === group.semester) {
          group.adminData = semester;
        }
      });
    });
  }
  const sortedFinalGroupsArr = finalGroupArr.sort((a, b) => a.semester - b.semester);
  const yearsArr = [
    [],
    [],
    [],
    [],
    [],
  ];
  sortedFinalGroupsArr.forEach((group) => {
    if (group.semester > 0 && group.semester < 3) {
      yearsArr[0].push(group);
    }
    if (group.semester > 2 && group.semester < 5) {
      yearsArr[1].push(group);
    }
    if (group.semester > 4 && group.semester < 7) {
      yearsArr[2].push(group);
    }
    if (group.semester > 6 && group.semester < 9) {
      yearsArr[3].push(group);
    }
    if (group.semester > 8 && group.semester < 11) {
      yearsArr[4].push(group);
    }
  });

  const pptx = new PptxGenJS();

  pptx.defineSlideMaster({
    title: 'COMPANY_BRANDING',
    margin: [0.5, 0.25, 1.00, 0.25],
    background: { color: '#c7effc' },
    objects: [],
    slideNumber: {
      x: 9.6,
      y: 5.2,
      w: 0.5,
      h: 0.3,
      color: '#252525',
    },
  });

  // adding slides
  addSlide1(pptx);
  addSlide2(pptx, company.name);
  yearsArr.forEach((year, index) => {
    if (year.length > 0) {
      addSlideProgram(pptx, addBrandingToSlide, year, index);
      addSlideExam(pptx, addBrandingToSlide, year, index);
    }
  });
  addSlide3(pptx);
  addSlide4(pptx, addBrandingToSlide, sortedCodes);
  addSlide5(pptx, addBrandingToSlide);
  addSlide6(pptx, addBrandingToSlide);
  addSlide7(pptx, addBrandingToSlide);
  addSlide8(pptx, addBrandingToSlide);

  if (upload) {
    const rawBlob = await pptx.write('blob');
    const pptxBlob = new Blob([rawBlob], {
      type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    });
    return pptxBlob;
  }
  pptx.writeFile({ fileName: `Presentation_${company.name}.pptx` });
}
